import { render, staticRenderFns } from "./TeamCard.vue?vue&type=template&id=da884400&scoped=true"
import script from "./TeamCard.vue?vue&type=script&lang=js"
export * from "./TeamCard.vue?vue&type=script&lang=js"
import style0 from "./TeamCard.vue?vue&type=style&index=0&id=da884400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da884400",
  null
  
)

export default component.exports